import * as Dark from './Dark/FirmableFull';
import { FirmableShort } from './FirmableShort';
import * as Light from './Light';

export const Logo = {
  Dark,
  FirmableShort,
  Light,
};
